<div class="container">
  <div class="content">
    <img class="logo" src="assets/icons/tc_logo.svg" alt="" />

    <div class="title-section">
      <h1 class="title">{{ message }}</h1>
      <h2 class="error" *ngIf="errorMsg">{{ errorMsg }}</h2>
    </div>

    <div class="signin-form">
      <div class="loading" *ngIf="loading">
        <div></div>
        <div></div>
      </div>

      <div class="loaded" *ngIf="!loading && !error">
        <img class="icon" src="assets/icons/checked-onboarding.svg" alt="" />
      </div>
    </div>

    <div class="footer">
      <p class="text" (click)="utils.openTyc()">Términos y Condiciones</p>
      <p class="text">© TiendaCrypto {{ actualYear }}</p>
    </div>
  </div>
</div>
